import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function AuthLoadingScreen({ title, subtitle }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: '#0A192F' }}
    >
      <div className="spinner mb-5" />
      <p className="text-base font-medium" style={{ color: '#F8F9FA' }}>
        {title}
      </p>
      {subtitle && (
        <p className="text-sm mt-2 max-w-md" style={{ color: '#A0ABC0' }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading, reconnecting } = useAuth();

  if (loading && !user) {
    return (
      <AuthLoadingScreen
        title="Verifica sessione in corso…"
        subtitle="Se il server era in pausa, l’avvio può richiedere fino a un minuto."
      />
    );
  }

  if (!user || user === false) {
    return <Navigate to="/login" replace />;
  }

  if (reconnecting) {
    return (
      <>
        <div
          className="px-4 py-2 text-center text-xs sm:text-sm"
          style={{
            backgroundColor: 'rgba(212, 175, 55, 0.12)',
            borderBottom: '1px solid rgba(212, 175, 55, 0.28)',
            color: '#D4AF37',
          }}
        >
          Server in avvio o connessione lenta — riconnessione automatica in corso…
        </div>
        {children}
      </>
    );
  }

  return children;
}

export default ProtectedRoute;
